// @flow
import * as React from 'react';

import styles from '../styles/ContentBox.scss';

type Props = {
  title?: string,
  id?: string,
  collapsable?: boolean,
  children?: React.Node,
  startCollapsed?: boolean,
}

type State = {
  collapsed: boolean,
}

class ContentBox extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      collapsed: props.startCollapsed || false,
    };
  }

  toggleCollapse = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    const { collapsable, id } = this.props;
    return (
      <div id={id} className={`${styles.contentBox} ${collapsable ? styles.collapsable : ''}`}>
        {this.props.title
          && <div className={styles.boxTitle} onClick={collapsable && this.toggleCollapse}>
            {this.props.title}
            {collapsable && <span>
              <i className={`${styles.arrow} ${this.state.collapsed ? styles.down : styles.up}`} />
            </span>
            }
          </div>
        }
        <div className={this.state.collapsed ? styles.collapsed : ''}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default ContentBox;



// WEBPACK FOOTER //
// ./client/src/components/ContentBox.jsx